import { useEffect } from "react";

const DEFAULT_TITLE = "DJ Ronaldo | Freestyle, Charme, Funk e Hip-Hop";
const DEFAULT_DESC =
  "Ouça os melhores sets de Freestyle, Charme, Funk e Hip-Hop com DJ Ronaldo. Web Rádio Clássicos do Funk 24h no ar.";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | DJ Ronaldo` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const setMeta = (selector, attr, value) => {
      const el = document.head.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", document.title);
    setMeta('meta[property="og:description"]', "content", desc);
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, description]);
}
